import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Loading from '../home/Loading';
import PdfFiles from '../AllData/PdfFiles'
import './Style/BookMarkedQuestions.css';
import StudyOption from "../AllData/HomeData";
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';


const BookMarkedPdfs = () => {
    const [bookmarkedPdfs, setBookmarkedPdfs] = useState([]);
    const [filteredPdfs, setFilteredPdfs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedSubject, setSelectedSubject] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const allPdfs = PdfFiles;
    const studyOptions = StudyOption;

    // Load bookmarks from localStorage 
    useEffect(() => {
        const fetchBookmarkedPdfs = () => {
            try {
                const storedBookmarks = localStorage.getItem('pdfBookmarks');
                if (storedBookmarks) {
                    const bookmarksData = JSON.parse(storedBookmarks);
                    setBookmarkedPdfs(bookmarksData);
                }
            } catch (err) {
                setError('Failed to load bookmarks from storage');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchBookmarkedPdfs();
    }, []);



    // Filter by selected subject
    useEffect(() => {
        if (selectedSubject === 'All') {
            setFilteredPdfs(bookmarkedPdfs);
        } else {
            setFilteredPdfs(bookmarkedPdfs.filter(bookmark => {
                const pdfData = getPdfData(bookmark.pdfId);
                return pdfData.subject === selectedSubject;
            }));
        }
        setCurrentPage(1);
    }, [bookmarkedPdfs, selectedSubject]);

    // Get PDF data from allPdfs or from stored bookmark data
    const getPdfData = (pdfId) => {
        const bookmarkData = bookmarkedPdfs.find(b => b.pdfId === pdfId);
        if (bookmarkData?.pdfData) return bookmarkData.pdfData;
        return allPdfs.find(pdf => pdf.id === pdfId) || {};
    };

    // Get unique subjects from bookmarks
    const getSubjects = () => {
        const subjectsSet = new Set(['All']);
        bookmarkedPdfs.forEach(bookmark => {

            const pdfData = getPdfData(bookmark.pdfId);
            if (pdfData.subject) subjectsSet.add(pdfData.subject);

        });
        return Array.from(subjectsSet);
    };

    // Remove specific bookmark from localStorage
    const handleRemoveBookmark = (pdfId) => {
        try {
            // Filter out the specific PDF for the current user
            const updatedBookmarks = bookmarkedPdfs.filter(
                bookmark => !(bookmark.pdfId === pdfId)
            );

            localStorage.setItem('pdfBookmarks', JSON.stringify(updatedBookmarks));
            setBookmarkedPdfs(updatedBookmarks);
        } catch (err) {
            setError('Failed to remove bookmark');
            console.error(err);
        }
    };

    if (loading) return <Loading message="Loading bookmarked PDFs..." />;
    if (error) return <div className="error-message">{error}</div>;

    const totalPages = Math.ceil(filteredPdfs.length / itemsPerPage);
    const currentPdfs = filteredPdfs
        .slice()
        .reverse()
        .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div className="bookmarked-container">

            <TopNavbar name={"Bookmarked PDFs " + "(" + filteredPdfs.length + ")"} />
            <TopHeader name={"Bookmarked PDFs " + "(" + filteredPdfs.length + ")"} />


            {currentPdfs.length > 0 ? (
                <div className="filter-controls">
                    {getSubjects().map(subject => (
                        <button
                            key={subject}
                            className={`filter-btn ${selectedSubject === subject ? 'active' : ''}`}
                            onClick={() => setSelectedSubject(subject)}
                        >
                            <p>{subject}</p>
                        </button>
                    ))}
                </div>
            ) : (<></>)}



            {currentPdfs.length === 0 ? (
                <div className="empty-state">
                    <p className="empty-message">
                        {selectedSubject === 'All'
                            ? "You haven't bookmarked any PDFs yet."
                            : `You haven't bookmarked any PDFs in ${selectedSubject}.`}
                    </p>
                </div>
            ) : (
                <div className="items-list">
                    {currentPdfs.map((bookmark, index) => {
                        const pdfData = getPdfData(bookmark.pdfId);
                        const globalIndex = ((currentPage - 1) * itemsPerPage + index + 1);

                        const matchingItem = studyOptions?.find(item => item.id === pdfData.type);
                        const iconName = matchingItem ? matchingItem.symbol : '📑';

                        return (
                            <div key={bookmark._id || bookmark.pdfId} className="item-card">

                                {pdfData.type === "formula" || pdfData.type === "flashcard" || pdfData.type === "ncertshortnote" || pdfData.type === "mindmap" || pdfData.type === "topernote" || pdfData.type === "ncertbook" || pdfData.type === "ncertsolution" ? (
                                    <>

                                        <div className="item-content">
                                            <div>
                                                <p className="item-text">{iconName}({globalIndex})  {pdfData.name || 'PDF'}</p>
                                                <span className="item-meta">({pdfData.type} • {pdfData.subject})</span>
                                            </div>
                                        </div>
                                        <div className="item-actions">
                                            <button
                                                onClick={() => handleRemoveBookmark(bookmark.pdfId)}
                                                className="action-btn remove-btn"
                                            >
                                                Remove
                                            </button>
                                            <Link
                                             to={`/onlinereadbook/${pdfData.type}/${pdfData.subject}/${pdfData.topic}`} 
                                              className="action-btn view-btn"
                                             >
                                                View PDF
                                            </Link>

                                        </div>

                                    </>
                                ) : (
                                    <>
                                        <div className="item-content">
                                            <div>
                                                <p className="item-text">{iconName}({globalIndex})  {pdfData.name || 'PDF'}</p>
                                                <span className="item-meta">({pdfData.type} • {pdfData.subject})</span>
                                            </div>
                                        </div>
                                        <div className="item-actions">
                                            <button
                                                onClick={() => handleRemoveBookmark(bookmark.pdfId)}
                                                className="action-btn remove-btn"
                                            >
                                                Remove
                                            </button>
                                            <a
                                                href={`/pdfs/${pdfData.pdfPath}`}
                                                className="action-btn view-btn"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View PDF
                                            </a>
                                        </div>
                                    </>
                                )}

                            </div>
                        );
                    })}
                </div>
            )}

            {currentPdfs.length > 9 && (

                <div className="pagination-controls">
                    <div className="pagination-info">
                        Total: {bookmarkedPdfs.length} | Page {currentPage} of {totalPages}
                    </div>
                    <div className="pagination-buttons">
                        <button
                            className="pagination-btn"
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        <button
                            className="pagination-btn"
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default BookMarkedPdfs;